import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2015-08-04",
    disableHostPrefix: false,
    regionInfoProvider: defaultRegionInfoProvider,
    signingName: "firehose",
};
//# sourceMappingURL=runtimeConfig.shared.js.map